// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgu_a bia_vt bia_ea bia_a","MenuItem__Btn":"bgu_b bia_z","MenuItem__subtitle":"bgu_c"};